import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledGrid = styled(Grid)(() => ({
  minWidth: "100%",
  minHeight: "100vh",
  padding: "1rem",
  marginBottom: "8rem",
}));
export default StyledGrid;
